import { Extension, isNodeEmpty } from '@tiptap/core';
import { Plugin, PluginKey } from '@tiptap/pm/state';

export const PRESERVE_HEADING_LEVEL_ON_EMPTY = 'preserveHeadingLevelOnEmpty';

/**
 * TipTap replaces a cleared heading with a default empty h1. Restore the
 * previous heading attrs so clear/blur keeps the chosen level.
 */
export const PreserveHeadingLevelOnEmpty = Extension.create({
  name: PRESERVE_HEADING_LEVEL_ON_EMPTY,

  addProseMirrorPlugins() {
    return [
      new Plugin({
        key: new PluginKey(PRESERVE_HEADING_LEVEL_ON_EMPTY),
        appendTransaction(transactions, oldState, newState) {
          if (!transactions.some((transaction) => transaction.docChanged)) {
            return null;
          }

          const oldHeading = oldState.doc.firstChild;
          const newHeading = newState.doc.firstChild;
          if (
            oldState.doc.childCount !== 1 ||
            newState.doc.childCount !== 1 ||
            oldHeading?.type.name !== 'heading' ||
            newHeading?.type.name !== 'heading' ||
            isNodeEmpty(oldHeading) ||
            !isNodeEmpty(newHeading)
          ) {
            return null;
          }

          const previousAttrs = oldHeading.attrs;
          const nextAttrs = newHeading.attrs;
          const attrsChanged = Object.keys(previousAttrs).some(
            (key) => previousAttrs[key] !== nextAttrs[key],
          );
          if (!attrsChanged) {
            return null;
          }

          return newState.tr.setNodeMarkup(0, undefined, previousAttrs);
        },
      }),
    ];
  },
});
